<template>
  <div class="error-page">
    <div v-if="!text" class="layout__header-mobile" id="header-text"></div>

    <c-list-empty
      style="margin-top: 50px;"
      :title="title"
      :description="description"
    ></c-list-empty>

    <div>
      <c-button
        theme="primary"
        v-if="attendeeId"
        size="sm"
        :to="homePageLink"
      >Go Home
      </c-button>
      <c-button
        v-else
        theme="primary"
        size="sm"
        :to="homePageLink"
      >Log in
      </c-button>
    </div>
  </div>
</template>

<script>
import common from "../../helpers/common";
import {ROUTES} from "../../router";

export default {
  // `text` is an optional message (e.g. a 422 flash) shown instead of the generic
  // status error. When present the component is used inline, so it must not touch
  // the shared mobile header.
  props: ['status', 'text'],
  data() {
    return {
      attendeeId: this.$route.params.attendeeId,
    }
  },
  computed: {
    homePageLink() {
      // TODO
      if (this.attendeeId) {
        return ROUTES.AGENDA_LAYOUT.replace(':attendeeId', this.attendeeId);
      }

      return ROUTES.ACCESS
    },

    title() {
      return this.text ? this.text : this.status;
    },

    description() {
      if (this.text) {
        return '';
      }

      switch (+this.status) {
        case 500:
          return 'Sorry. Something went wrong.';
        case 403:
          return 'Sorry. You don’t have permission to view this page.';
        case 404:
          return 'Sorry. Page not found.';
        default:
          return 'Sorry. Something went wrong.';
      }
    }
  },
  mounted() {
    // Only a full-page error should update the header; an inline message must keep
    // the current page header intact.
    if (!this.text) {
      common.setHeaderText(`Error ${this.status}`);
    }
  },
}
</script>

<style scoped lang="scss">
.layout__header-mobile {
  display: none;
  background-color: var(--attendee-brand-color);
  position: fixed;
  width: 100%;
  z-index: 99;
  top: 0;
  color: white;
  height: var(--attendee-header-mobile-height);
  font-size: 21px;

  @media (max-width: 900px) {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.error-page {
  padding: 60px;
  text-align: center;
}
</style>
